export { default as Slider } from './Slider/Slider';
export { default as HotOffers } from './HotOffers/HotOffers';
export { default as AppBanner } from './AppBanner/AppBanner';
export { default as Products } from './Products/Products';
export { default as News } from './News/News';
export { default as NewsList } from './News/NewsList';
export { default as BookNumber } from './BookNumber/BookNumber';
export { default as Tariffs } from './Tariffs/Tariffs';
export { default as InternetBundles } from './InternetBundles/InternetBundles';
export { default as FixServices } from './FixServices/FixServices';
export { default as TechnicalSolutions } from './TechnicalSolutions/TechnicalSolutions';
export { default as BrandSlider } from './BrandSlider/BrandSlider';
export { default as VolteBanner } from './VolteBanner/VolteBanner';
